import { AssignmentEntry } from '../entries';
import { AssignmentData } from './AssignmentData';

export interface AssignmentDataWithEntries<T extends AssignmentData = AssignmentData> {
  assignmentData: T;
  entries: AssignmentEntry[];
}

export namespace AssignmentDataWithEntries {
  export type Realtime = AssignmentDataWithEntries<AssignmentData.Realtime>;

  export function from(
    assignmentData: AssignmentData | undefined,
    entries: AssignmentEntry[]
  ): AssignmentDataWithEntries | undefined {
    if (!assignmentData) {
      return undefined;
    }

    return {
      assignmentData: assignmentData,
      entries: entries,
    };
  }

  export function isRealtime(data: AssignmentDataWithEntries): data is Realtime {
    return AssignmentData.isRealtime(data.assignmentData);
  }

  export function asRealtime(data: AssignmentDataWithEntries): Realtime | undefined {
    return isRealtime(data) ? data : undefined;
  }
}
